import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const DocumentsVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "v1.0/Documents",
    $_documents: [],
    $_currentDocument: {},
    $_errorState: {},
    $_actionState: {
      message: "",
      status: 200,
      data: {}
    }
  }),
  getters: {
    allDocuments: (state) => state.$_documents,
    currentDocument: (state) => state.$_currentDocument,
    actionState: (state) => state.$_actionState,
    errorState: (state) => state.$_errorState
  },
  actions: {
    initDocument({ commit }) {
      var document = {
        id: 0,
        name: "",
        useCustomNaming: false,
        namingSqlQuery: "",
        namingTemplate: "",
        onePdfPerPage: false,
        previewEnabled: false,
        isActive: false
      };

      commit("SET_DOCUMENT", document);
    },
    clearDocuments({ commit }) {
      commit("SET_DOCUMENTS", []);
    },
    setDocument({ commit }, document) {
      commit("SET_DOCUMENT", document);
    },
    async getDocuments({ commit, dispatch, state, rootGetters }) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_DOCUMENTS", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async getDocument({ commit, dispatch, state, rootGetters }, id) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.get(actionLink, axiosConfig);
        commit("SET_DOCUMENT", response.data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },

    async createDocument({ commit, dispatch, state, rootGetters }, document) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        document.id = 0;
        const response = await axios.post(actionLink, document, axiosConfig);
        document.id = response.data.id;
        commit("SET_DOCUMENT", document);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async updateDocument({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        const response = await axios.put(
          actionLink,
          data.document,
          axiosConfig
        );
        data.document.id = response.data.id;

        commit("SET_DOCUMENT", data.document);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async deleteDocument({ commit, dispatch, state, rootGetters }, data) {
      var baseUrl = rootGetters.baseUrl;
      var actionLink = baseUrl + state.$_moduleApiPath + "/" + data.id;
      var axiosConfig = rootGetters.axiosConfig;
      var $_axiosConfig = JSON.parse(JSON.stringify(axiosConfig));
      $_axiosConfig.data = data;
      try {
        const response = await axios.delete(actionLink, $_axiosConfig);
        data.id = response.data.id;
        commit("SET_DOCUMENT", data);
      } catch (error) {
        commit("SET_ERROR", error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_DOCUMENTS(state, value) {
      state.$_documents = value;
    },
    SET_DOCUMENT(state, value) {
      state.$_currentDocument = value;
    },
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

export default DocumentsVuexModule;
